export const enum LibrarySaveStatus {
  NotSaved = 0,
  Saved = 1,
  Archived = 2
}